import { EPS } from './qty.js';

// Skema diskon bertingkat (formulir owner): tingkat diatur per (divisi produk, satuan), tetapi berlaku PER ITEM —
// qty tiap produk dihitung sendiri, tidak digabung dengan varian lain satu divisi (keputusan owner 5 Nov 2026:
// OKM 10 bal + Segi Tiga 5 bal → OKM Rp5.000/bal, Segi Tiga Rp2.500/bal). Potongan per satuan = tingkat tertinggi yang
// min_qty-nya terpenuhi (batas ikut: 1–9, 10–49, …); di bawah tingkat terendah (mis. 0,5 bal) tanpa diskon.
// Produk tanpa divisi = tanpa diskon.

export interface DiscountTier {
  division: string;
  unit: string;
  min_qty: number;
  disc: number;
}

export interface DiscountLine {
  division: string | null | undefined;
  unit: string;
  qty: number;
  price: number;
}

const dkey = (div: unknown, unit: unknown) =>
  `${String(div || '')
    .trim()
    .toLowerCase()}|${String(unit || '')
    .trim()
    .toLowerCase()}`;

/** Diskon per satuan untuk tiap baris (urutan sama dengan `lines`; satu baris = satu produk & satuan), tidak pernah
 *  melebihi harga. */
export function discountsFor(lines: readonly DiscountLine[], tiers: readonly DiscountTier[]): number[] {
  const sorted = [...tiers].sort((a, b) => a.min_qty - b.min_qty);
  return lines.map((l) => {
    let d = 0;
    if (l.division) {
      const k = dkey(l.division, l.unit);
      const qty = Number(l.qty) || 0;
      for (const t of sorted) if (dkey(t.division, t.unit) === k && qty + EPS >= t.min_qty) d = t.disc;
    }
    return Math.min(d, l.price);
  });
}
